import CompraList from './CompraList'
export {CompraList}
export default CompraList
